import styles from "./UserInitials.module.scss";

type UserInitialsProps = {
  userName: string;
};

export const UserInitials = ({ userName }: UserInitialsProps) => {
  const parts = userName.split(" ")
  let first, second, third = null;

  let fLetter, sLetter, tLetter;
  switch(parts.length) {
    case 1:
      [first] = parts;
      fLetter = first[0].toUpperCase()
      break;
    case 2:
      [first, second] = parts;
      fLetter = first[0].toUpperCase()
      sLetter = second[0].toUpperCase()
      break;
    default:
      [first, second, third] = parts;
      fLetter = first[0].toUpperCase()
      sLetter = second[0].toLowerCase()
      tLetter = third[0].toUpperCase()
  }

  const string = `${fLetter}.` + (second ? `${sLetter}.` : '') + (third ? `${tLetter}.` : '');

  return <div className={styles.wrapper}>{string}</div>;
};
